import React, { useState, useEffect, useRef } from 'react'; //ai useRef
import { useNavigate } from 'react-router-dom';
import { UrlDev } from './url'; // ✅ Import your base URL
import { authFetch } from './utils/api'; // ✅ Import fetch wrapperL
import { useLocation } from 'react-router-dom';
import { alertC, confirmC } from './components/dialogService';
import DrawScreen from './DrawScreen';

import MagicGlass from './windows/wint/MagicGlass';
import DrawTopViewScreen from './DrawTopViewScreen';
import { KOEFF, FRAME_WIDTH, OFFSET_X, OFFSET_Y } from './PleatedSreenConstants';



import ItemSelector from './itemselector'; // Ensure the path is correct and in lowercase
import ExpandableSection from './expandablesection';
import './entrydoor.css'; // Import the CSS file for styles
import './toolbar.css';
import './spinner.css';
import LocationTag from './controls/LocationTag';
import Notes from './controls/Notes';
import Quantity from './controls/frame/Quantity';
import Discount from './controls/frame/Discount';
import MeasurmentType from './controls/screen/MeasurmentType';
import FrameWidthEticomN from './controls/frame/eticom/FrameWidthEticomN';
import FrameHeightEticomN from './controls/frame/eticom/FrameHeightEticomN';
import MagnetLatch from './controls/screen/MagnetLatch';
import SubFrame from './controls/screen/SubFrame';
import ExteriorDoor from './controls/finish/ExteriorDoor';
import GentekColor from './controls/finish/GentekColor';
import CascadingCombo from './additional/CascadingCombo';

import { toPdf, toPdfAuto } from './components/toPdf';
import EmailDialog from './records/EmailDialog';

import ViewDetails from './docs/viewdetails'; // Import sliding window
import { formatToDecimal } from './controls/conversions';
import { formatToFractional } from './controls/conversions';
import { getCookie } from './utils/cookies';
import { authFetchRequest } from './utils/api';
import { getCustomerEmail } from './utils/QuickDataAccess';

const PleatedScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { quoteId, quoteItemId, fkCustomerId, fkUserId, viewItem, reference_no } = location.state || {};
  const [newQuoteItemId, setNewQuoteItemId] = useState(quoteItemId || null);
  const [lastDateSaved, setLastDateSaved] = useState("NA");
  const [isDisabled, setIsDisabled] = useState(false);

  const pattern =  'AccordionShadow';
  const doorTypes = [
    { id: 1, name: 'Single Leaf (max. 3m or 118")',  imageUrl: '/images/door-1.png' },
    { id: 2, name: 'Double Leaf (max. 6m or 236") ', imageUrl: '/images/door-5.png' },
  ];
   const [doorData, setDoorData] = useState({});
   const [isViewDetailsVisible, setIsViewDetailsVisible] = useState(false);
   const [viewDetailsData, setViewDetailsData] = useState([]);
   const [hasLoaded, setHasLoaded] = useState(false);
   const [displayPrices, setDisplayPrices] = useState(false);
 
 
   const itemSelectorRef = useRef(null); //ai
   const [selectedDoor, setSelectedDoor] = useState(null);
   const [isFrameValid, setIsFrameValid] = useState(true);

   //---setters functions....
  const [quantityValue, setQuantityValue] = useState("");
  const [discountValue, setDiscountValue] = useState(0);

  const [measurementTypeValue, setMeasurementTypeValue] = useState("Screen Size");
  const [frameWidthValue, setFrameWidthValue] = useState("40\"");
  const [frameHeightValue, setFrameHeightValue] = useState("80\"");
  const [magnetLatchValue, setMagnetLatchValue] = useState("");
  const [subFrameValue, setSubFrameValue] = useState("");

  const [screenFrameColorValue, setScreenFrameColorValue] = useState("White");
  const [gentekColorValue,  setGentekColorValue]  = useState({ value: "", label: "" });
  const [locationTagValue, setLocationTagValue] = useState("");
  const [notesValue, setNotesValue] = useState("");

  const requiredKeys = ["CascadingCombo1", "CascadingCombo2", "CascadingCombo3", "CascadingCombo4", "CascadingCombo5"];
  const [CascadingComboValue,  setCascadingComboValue]   = useState([]);
  const [CascadingComboValue1, setCascadingComboValue1]  = useState();
  const [CascadingComboValue2, setCascadingComboValue2]  = useState();
  const [CascadingComboValue3, setCascadingComboValue3]  = useState();
  const [CascadingComboValue4, setCascadingComboValue4]  = useState();
  const [CascadingComboValue5, setCascadingComboValue5]  = useState();
  const [isLoading, setIsLoading] = useState(false);

  //email dialog
  const [showEmailDialog, setShowEmailDialog] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [customerEmail, setCustomerEmail] = useState("");

  useEffect(() => {
    const loadEmail = async () => {
      const email = await getCustomerEmail(fkCustomerId);
      setCustomerEmail(email || "no customer email found");
    };
  
    if (fkCustomerId) {
      loadEmail();
    }
  }, [fkCustomerId]);

  const handleSendEmail = async (recipient) => {
    setShowEmailDialog(true); 
  };

  const handlePdfDownload = async () => {
    setIsLoading(true);
    try {
      // toPdfAuto picks server-side vs legacy based on USE_PDF_SERVER (constants.js).
      await toPdfAuto({
        container: ".view-details",
        filename: `${doorData?.frameData?.selectedDoor?.name || "No name available"}`,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSaveQuote = async (bSaveAndBack = false) => {
     try {
       const userId    = getCookie('user_id');
 
       if (parseInt(userId) !== parseInt(fkUserId)){
        await alertC("this quote item doesn't belong to you, you can't modify and save it.")
        //alert("userId:" + parseInt(userId) + ", fkUserId:" + parseInt(fkUserId));
         if (bSaveAndBack) {
           navigate('/quotes', {
             state: {
               quoteId: quoteId,           // ID of the parent quote
               quoteItemId: quoteItemId    // ID of the updated item (optional)
             }
           });
         }
         return;
       }
       const date = new Date();
       const formattedDate = date.toLocaleDateString('en-US', {
         year: '2-digit', 
         month: '2-digit', 
         day: '2-digit'
       });
       setLastDateSaved(formattedDate); //put the new last date...
       doorData.document.orderDate = formattedDate;
         
       if (!quoteId && !quoteItemId) {
         await alertC('create new Quote and NEW item')
       }
       if (quoteId && !quoteItemId && !newQuoteItemId) {//('Save NEW item in existing Quote')
         const payload = {
           fkQuoteId: quoteId,
           doorData: doorData,
           itemType: "pleatedscreen" 
         };
         const itemRow = await authFetchRequest(
                           `/itemquotes/`,
                           payload,
                           "POST",
                           { Authorization: `Bearer ${getCookie("access_token")}` }
                       );
                       setNewQuoteItemId(itemRow?.id);
          //alert(JSON.stringify(itemRow, null, 2));
       }//^^^     
       if ((quoteId && quoteItemId) || (quoteId && newQuoteItemId)) { //Quote & ItemQuote exist, just re-save
           const payload = {
             fkQuoteId: quoteId,
             doorData: doorData 
           };
           const currentQuoteItemId = quoteItemId || newQuoteItemId;
           const itemRow = await authFetchRequest(
                             `/itemquotes/${currentQuoteItemId}`,
                             payload,
                             "PUT",
                             { Authorization: `Bearer ${getCookie("access_token")}` }
                         );
       }//^^^
       if (bSaveAndBack) {
           navigate('/quotes', {
             state: {
               quoteId: quoteId,           // ID of the parent quote
               quoteItemId: quoteItemId    // ID of the updated item (optional)
             }
           });
       }
       return;
 
     } catch (err) {
       console.error("❌ Failed to save quote and item quote:", err);
       alert("Failed to save.");
     }
   };

  useEffect(() => {
        setCascadingComboValue1(CascadingComboValue[0]?.value || "NA");
        setCascadingComboValue2(CascadingComboValue[1]?.value || "NA");
        setCascadingComboValue3(CascadingComboValue[2]?.value || "NA");
        setCascadingComboValue4(CascadingComboValue[3]?.value || "NA");
        setCascadingComboValue5(CascadingComboValue[4]?.value || "NA");
  }, [CascadingComboValue]); // ✅ Ensures state updates when cascadingComboValue changes
  
  useEffect(() => {
    if (viewItem === 'readonly'){
      setIsDisabled(true);
      setDisplayPrices(true);
    }
    const fetchData = async () => {
      try {
        if (!quoteId || !quoteItemId) {
          console.warn("❌ Missing quoteId or quoteItemId—skipping fetch.");
          return;
        }
  
        console.log(`🔍 Fetching data from: ${UrlDev}/itemquotes/${quoteItemId}`);
        const data = await authFetch(`/itemquotes/${quoteItemId}`);
        console.log("✅ API Response Data:", JSON.stringify(data, null, 2));
  
        if (!data?.doorData) {
          console.warn("❌ No valid doorData found.");
          alert("No valid doorData found.");
          return;
        }
  
        // Set the doorData state
        setDoorData(data.doorData);
  
        // Check if `selectedDoor` exists in `frameData`
        const selectedDoorItem = data.doorData?.frameData?.selectedDoor;
  
        if (selectedDoorItem) {
          console.log("✅ Selected door detected:", selectedDoorItem.name);
          
          // Update item selector via ref
          if (itemSelectorRef.current) {
            itemSelectorRef.current.setSelectedItem(selectedDoorItem.name);
          }
  
          setSelectedDoor(selectedDoorItem); // Update state
          setFormData(data.doorData); // Populate form
          setIsViewDetailsVisible(true);
        }
  
        setHasLoaded(true); // Mark as loaded
  
      } catch (error) {
        console.error("❌ Fetch error:", error);
        alert(`Error: ${error.message}`);
      }
    };
  
    fetchData();
  }, [quoteId, quoteItemId]); // Runs when these values change    
    
  

    // Function to map doorData to state setters
    const setFormData = (doorData) => {
          setQuantityValue(doorData?.frameData?.quantity || "1");
          setDiscountValue(doorData?.discounts?.discount || "0");
          setFrameWidthValue(doorData?.frameData?.frameWidth || "40\"");
          setFrameHeightValue(doorData?.frameData?.frameHeight || "80\"");
          setMeasurementTypeValue(doorData?.frameData?.measurementType || "Screen Size");
          setMagnetLatchValue(doorData?.frameData?.magnetLatch || "");
          setSubFrameValue(doorData?.frameData?.subFrame || "");
          setScreenFrameColorValue(doorData?.frameData?.screenFrameColor || "White");
          setGentekColorValue ({value: doorData?.frameData?.gentekColor, label: doorData?.frameData?.gentekColor_label});
          setLocationTagValue(doorData?.notes?.LocationTag || "");
          setNotesValue(doorData?.notes?.notes || "");

          if (doorData?.additionalItems !== undefined){
              setCascadingComboValue1(doorData?.additionalItems?.CascadingCombo1 || "NA");
              setCascadingComboValue2(doorData?.additionalItems?.CascadingCombo2 || "NA");
              setCascadingComboValue3(doorData?.additionalItems?.CascadingCombo3 || "NA");
              setCascadingComboValue4(doorData?.additionalItems?.CascadingCombo4 || "NA");
              setCascadingComboValue5(doorData?.additionalItems?.CascadingCombo5 || "NA");
              //alert(JSON.stringify(doorData.additionalItems, null, 2));
              const convertedCombos = Object.entries(doorData?.additionalItems)
                    .filter(([_, val]) => val !== "NA")
                    .map(([id, value]) => ({ id, value }));
              setCascadingComboValue(convertedCombos);
          }
          const date = new Date();
          const formattedDate = date.toLocaleDateString('en-US', {
            year: '2-digit', 
            month: '2-digit', 
            day: '2-digit'
          });
          setLastDateSaved(doorData?.document?.orderDate || date);
    };
  
    const toggleViewDetails = () => {
        setIsViewDetailsVisible((prev) => !prev); // Toggle window
    };
    const togglePrices = () => {
      setDisplayPrices(!displayPrices);
  };
  
  function calculateMinMax(selectedDoor) {
    if (!selectedDoor || !selectedDoor.id) {
      return {
        minW: 0,
        maxW: 0,
        minH: 0,
        maxH: 0,
      };
    }
  
    switch (selectedDoor.id) {
      case 1:
        return {
          minW: 20,
          maxW: 118,
          minH: 20,
          maxH: 125,
        };
  
      case 2:
        return {
          minW: 30,
          maxW: 236,
          minH: 20,
          maxH: 125,
        };
  
      default:
        return {
          minW: 0,
          maxW: 0,
          minH: 0,
          maxH: 0,
        };
    }
  }

  const { minW, maxW, minH, maxH } = calculateMinMax(selectedDoor);

  const controlMap = [
  
    { id: "LocationTag", component: <LocationTag  
          disabled={isDisabled}
          value={locationTagValue} // ✅ScreenDetails Pass current state value  
          onChange={(newValue) => 
          { setLocationTagValue(newValue); }
    }/>, position: [1, 1], status: "active", expandableSectionId: "Notes" },

    { id: "Notes",  component: <Notes  
      disabled={isDisabled}
      value={notesValue} // ✅ScreenDetails Pass current state value  
      onChange={(newValue) => 
      { setNotesValue(newValue); }
    }/>, position: [2, 1], status: "active", expandableSectionId: "Notes" },

 // Section - ScreenDetails starts   
    { id: "Quantity",    component: <Quantity
          disabled={isDisabled}
          value={quantityValue} // ✅ScreenDetails Pass current state value  
          onChange={(newValue) => 
          { setQuantityValue(newValue); }
    }/>, position: [1, 1], status: "active", expandableSectionId: "ScreenDetails" },

    { id: "MeasurmentType",    component: <MeasurmentType
          disabled={isDisabled}
          value={measurementTypeValue} //   
          onChange={(newValue) => 
          { setMeasurementTypeValue(newValue); }
    }/>, position: [2, 1], status: "active", expandableSectionId: "ScreenDetails" },

    { id: "FrameWidth",  component: <FrameWidthEticomN 
          disabled={isDisabled}
          value={frameWidthValue} // ✅ Pass current state value
          onChange={(newValue) => { setFrameWidthValue(newValue); }}
          label="Screen Width"
          passSelectedDoor={selectedDoor}
          minValue={minW}
          maxValue={maxW}
          onValidChange={(isValid) => setIsFrameValid(isValid)}
      />, position: [2, 2], status: "active", expandableSectionId: "ScreenDetails" },
    { id: "FrameHeight",  component: <FrameHeightEticomN
         disabled={isDisabled}
         label="Screen Height"
         value={frameHeightValue} // ✅ Pass current state value
         minValue={minH}
         maxValue={maxH}
         onChange={(newValue) => { setFrameHeightValue(newValue); }       
    }/>, position: [2, 3], status: "active", expandableSectionId: "ScreenDetails" },

    { id: "MagnetLatch",    component: <MagnetLatch
          disabled={isDisabled}
          value={magnetLatchValue} //   
          onChange={(newValue) => 
          { setMagnetLatchValue(newValue); }
    }/>, position: [3, 1], status: "active", expandableSectionId: "ScreenDetails" },

    { id: "SubFrame",    component: <SubFrame
          disabled={isDisabled}
          value={magnetLatchValue} //   
          onChange={(newValue) => 
          { setSubFrameValue(newValue); }
    }/>, position: [3, 2], status: "inactive", expandableSectionId: "ScreenDetails" },

    { id: "ScreenFrameColor", component: <ExteriorDoor 
          disabled={isDisabled}
          value={screenFrameColorValue} // ✅ Pass current state value
          onChange={(newValue) => 
          { setScreenFrameColorValue(newValue); 
          console.log("Screen Frame Color changed to:", newValue)}
          }  label="Screen Frame Color" />,  
      position: [4, 1], status: "active", expandableSectionId: "ScreenDetails" },

  { id: "GentekColor", component: <GentekColor controlId={1} 
        disabled={isDisabled}
        value={gentekColorValue} // ✅ Pass current state value 
        onChange={(newValue) => 
        { setGentekColorValue(newValue); 
        console.log("GentekColor changed to:", newValue)}
        }
        label='Screen Frame Color' color={screenFrameColorValue}/>,   
      position: [4, 2], status: "active", expandableSectionId: "ScreenDetails" },

{ id: "CascadingCombo", component: <CascadingCombo 
      disabled={isDisabled}
      label = 'item'
      value={CascadingComboValue}
      onChange={(newValue) => 
      { setCascadingComboValue(newValue); 
      console.log("CascadingCombo changed to:", newValue)}
  }     
/>,  // ✅ Render your component inside the expandable panel
position: [1, 1], // Adjust position as needed
status: "active",
expandableSectionId: "AdditionalItems"
},  

    { id: "Discount",    component: <Discount
      disabled={isDisabled}
      label="Discount %"
      value={discountValue} // ✅ Pass current state value  
      onChange={(newValue) => 
      { setDiscountValue(newValue); }
    }/>, position: [1, 1], status: "active", expandableSectionId: "Discounts" },

  ];
  
  if (!doorData.calc) {
    setDoorData((prev) => ({
      ...prev,
      calc: {
        baseSubtotal: null,
        subtotal: null,
        discountedSubtotal: null,
        tax: null,
        total: null,
      },
    }));
  }
  // Callback to update calc data
  const updateCalcData = (newCalc) => {
    setDoorData((prev) => ({
      ...prev,
      calc: {
        ...prev.calc,
        ...newCalc, // Merge new calc values
      },
    }));
  };
  

  ///let doorData = {}; - old one
  doorData.calc = doorData.calc || {};
  doorData.frameData = {}; 
  doorData.notes = {};
  doorData.additionalItems = {};
  doorData.discounts = {};
  doorData.document = {};
  doorData.document.type = "Pleated Screen";
  doorData.document.orderNumber = `${quoteId}/${quoteItemId || newQuoteItemId || 'new item'}`; //, fkCustomerId
  doorData.document.reference = `${reference_no}`;
  doorData.document.orderDate = `${lastDateSaved}`;
  doorData.quoteTemplate = "pleated_screen_template";
  doorData.priceRules    = "pleated_screen_priceRules";
  doorData.displayPrices = displayPrices;
  doorData.quote = 1;
  doorData.frameData.quantity = quantityValue || 1;
  doorData.discounts.discount = discountValue || 0;

  doorData.frameData.adjustView = true;
  doorData.frameData.isValidW =  (formatToDecimal(frameWidthValue)  >=minW && formatToDecimal(frameWidthValue)  <= maxW);
  doorData.frameData.isValidH =  (formatToDecimal(frameHeightValue) >=minH && formatToDecimal(frameHeightValue) <= maxH);

  if (doorData.frameData.isValidW){
    doorData.frameData.frameWidthLabel = frameWidthValue;
    doorData.frameData.frameWidth = formatToDecimal(frameWidthValue);
    doorData.frameData.frameWidthRound = Math.round(doorData.frameData.frameWidth);
  }
  else{
    if (formatToDecimal(frameWidthValue) < minW) {
    doorData.frameData.frameWidthLabel = minW + "\"";
    doorData.frameData.frameWidth = minW;
    doorData.frameData.frameWidthRound = minW;
    }
    else{
      doorData.frameData.frameWidthLabel = maxW + "\"";
      doorData.frameData.frameWidth = maxW;
      doorData.frameData.frameWidthRound = maxW;      
    }
  }
  if (doorData.frameData.isValidH){
    doorData.frameData.frameHeightLabel = frameHeightValue;
    doorData.frameData.frameHeight = formatToDecimal(frameHeightValue);
    doorData.frameData.frameHeightRound = Math.round(doorData.frameData.frameHeight);
  } 
  else{
    if (formatToDecimal(frameHeightValue) < minH) {
      doorData.frameData.frameHeightLabel = minH + "\"";
      doorData.frameData.frameHeight = minH;
      doorData.frameData.frameHeightRound = minH;
      }
      else{
        doorData.frameData.frameHeightLabel = maxH + "\"";
        doorData.frameData.frameHeight = maxH;
        doorData.frameData.frameHeightRound = maxH;      
      }    
  }

  doorData.frameData.measurementType = measurementTypeValue;
  doorData.frameData.magnetLatch = magnetLatchValue;
  doorData.frameData.subFrame = subFrameValue;

  doorData.frameData.screenFrameColor   = screenFrameColorValue;
  doorData.frameData.gentekColor        = gentekColorValue.value;
  doorData.frameData.gentekColor_label  = gentekColorValue.label;

  doorData.notes.LocationTag        = locationTagValue;
  doorData.notes.notes              = notesValue;

  CascadingComboValue.forEach(({ id, value }) => {
    doorData.additionalItems[id] = value;
  });
  requiredKeys.forEach(key => {
    if (!doorData.additionalItems.hasOwnProperty(key)) {
        doorData.additionalItems[key] = "NA";
    }
  });


  doorData.frameData.selectedDoor = selectedDoor;
 
  const doorDataCopy = { ...doorData };
  const doorDataCopy2 = { ...doorData }; 
  //alert(JSON.stringify(doorData, null, 2));
 //aaa


  return (
<div className='entire-container'>
    <div className="door-container">
      <div className="toolbar-container">
        <div className="toolbar">
            <button
              className="toolbar-button"
              onClick={toggleViewDetails}
            >
              {isViewDetailsVisible ? "Hide Details" : "View Details"}
            </button>
            <button className="toolbar-button" onClick={togglePrices} disabled={!isViewDetailsVisible} >
              {displayPrices ? "Hide Prices" : "Show Prices"}
            </button>
            <button
              className={`toolbar-button ${isLoading ? "loading" : ""}`}
              onClick={handlePdfDownload}
              disabled={!isViewDetailsVisible || isLoading}
            >
            {isLoading ? (
              <span className="spinner"></span>
            ) : (
              "📄 PDF"
            )}
            </button>
            <button className={`toolbar-button`}  onClick={() => handleSendEmail(true)} disabled={!isViewDetailsVisible} >
              ✉️ Email
            </button>
            <button className={`toolbar-button`}  onClick={() => handleSaveQuote(false)}>
              💾 Save
            </button>
            <button className={`toolbar-button`}  onClick={() => handleSaveQuote(true)}>
              💾 Save & Exit
            </button>
            <button className={`toolbar-button`}onClick={() => setIsDisabled(prev => !prev)}>
            {isDisabled ? "Enable Form" : "Disable Form"}
            </button>
        </div>
      </div>
      <ExpandableSection title1="Select Screen Type" state="true">
        <ItemSelector ref={itemSelectorRef} items={doorTypes} selectedDoor={selectedDoor} onSelect={setSelectedDoor} disabled={isDisabled} />
      </ExpandableSection>
      {selectedDoor && (
        <div >
          <div >
          <div className="door"><p>{selectedDoor.name}</p></div>
          </div>
          <ExpandableSection 
            title="Screen Details" 
            panelLocation="2"
            controlMap={controlMap.filter((control) => control.expandableSectionId === "ScreenDetails")}
            state="true" >
          </ExpandableSection>

          <ExpandableSection 
            title="Additional Items" 
            panelLocation="6"
            controlMap={controlMap.filter((control) => control.expandableSectionId === "AdditionalItems")}    
          />

          <ExpandableSection
            title="Notes"
            panelLocation="7"
            controlMap={controlMap.filter((control) => control.expandableSectionId === "Notes")}
            state="true" >
          </ExpandableSection>

          <ExpandableSection
            title="Discounts"
            panelLocation="8"
            controlMap={controlMap.filter((control) => control.expandableSectionId === "Discounts")}
          />
        </div>
      )}
    </div>
    <div className="door-container shift-down image-container"  >
      {selectedDoor ? 
        <div className="fixed-container">
          <p>{doorData?.frameData?.selectedDoor.name}</p>
          <MagicGlass width={Math.max(250, doorData?.frameData?.frameWidth * KOEFF + 65 + 0)} 
                      height={doorData?.frameData?.frameHeight * KOEFF + 120 + 0} 
          > 
          <DrawScreen doorData={doorDataCopy2} pattern={pattern}/>
          <DrawTopViewScreen doorData={doorDataCopy} /> 
          </MagicGlass>
        </div> : 'select sizes to create an image'}        
    </div>
 

            {/*<ViewDetails isVisible={isViewDetailsVisible} data={viewDetailsData} />*/}
            {selectedDoor && (
            <ViewDetails
                  isVisible={isViewDetailsVisible}
                  data={viewDetailsData}
                  doorData={doorDataCopy}
                  updateCalcData={updateCalcData} // Pass the callback
                  drawing={
                    selectedDoor ? (
                      <DrawScreen doorData={doorDataCopy2} pattern={pattern}/>                     
                    ) : null
                  } 
                  drawTopView={
                    selectedDoor ? <DrawTopViewScreen doorData={doorDataCopy} /> : null
              }                
            />
                )}

 
            {/* end of View Details Sliding Window */}
            {showEmailDialog && (
            <EmailDialog
              isOpen={showEmailDialog}
              onClose={() => setShowEmailDialog(false)}
              isSending={isSending}
              setIsSending={setIsSending}
              customerEmail={customerEmail}
              /*container=".view-details"         // optional, default is ".view-details"
              filename="Quote"                  // optional
              subject="Your Quote PDF"          // optional
              message="Hello ,Please find your quote PDF attached." // optional*/
            />
            )}     
  </div>
  );
};

export default PleatedScreen;
